import "./GetStarted.module.css";
import Header from "@/reusable_sections/Header";
import Strategy from "./sections/Strategy";
import Inquiry from "./sections/Inquiry";
import Office from "./sections/Office";
import Footer from "@/reusable_sections/Footer";
export default function GetStartedPage() {
  return <div>
      <Header />
      <Strategy />
      <Inquiry />
      <Office />
      <Footer />
    </div>;
}